import { getMiniCart, showMiniCart } from './mda-mini-cart';

// AJAX ADD TO CART
(function ($) {
    // Product listing add to cart button

    $("input[name='quantity']").on('input', function () {
        var max = parseInt($(this).attr('max'));
        var value = parseInt($(this).val());

        if (max) {
            if (value > max) {
                $('.single_add_to_cart_button').addClass('-disabled');
            } else {
                $('.single_add_to_cart_button').removeClass('-disabled');
            }
        }
    });

    $(document).ready(function ($) {
        $('form.cart').on('keyup keypress', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });
    });

    $(document).on('click', '.js-single-add-to-cart', function (e) {
        e.preventDefault();
        const button = $(this);
        let product_id = button.val();
        let quantity = $('body').find('[name="quantity"]').val();
        let price = $('body').find('[name="updated_price"]').val();
        let user_label = $('body').find('[name="user_label"]').val();
        let user_comment = $('body').find('[name="user_comment"]').val();
        let non_prefabricated = $('body').find('[name="non_prefabricated"]').val();
        let accessories = $('body')
            .find('[name="configurator_accesories"]')
            .val();

        if (!product_id || price == 0) return;

        addToCart({
            button: button,
            productId: product_id,
            qty: quantity,
            additionalData: {
                updated_price: price,
                configurator_accesories: accessories,
                user_label: user_label,
                user_comment: user_comment,
                non_prefabricated: non_prefabricated,
            },
        });
    });

    // Variation
    $(document).on('click', '.js-variation-add-to-cart', function (e) {
        e.preventDefault();

        const button = $(this);
        let product_id = $('body').find('[name="product_id"]').val();
        let variation_id = $('body').find('[name="variation_id"]').val();
        let quantity = $('body').find('[name="quantity"]').val();
        let price = $('body').find('[name="updated_price"]').val();
        let user_label = $('body').find('[name="user_label"]').val();
        let user_comment = $('body').find('[name="user_comment"]').val();
        let non_prefabricated = $('body').find('[name="non_prefabricated"]').val();
        let accessories = $('body')
            .find('[name="configurator_accesories"]')
            .val();

        if (variation_id == 0 || product_id == 0 || price == 0) return;

        addToCart({
            button: button,
            productId: product_id,
            qty: quantity,
            variationId: variation_id,
            additionalData: {
                updated_price: price,
                configurator_accesories: accessories,
                user_label: user_label,
                user_comment: user_comment,
                non_prefabricated: non_prefabricated,
            },
        });
    });

    const loadingClass = 'is-loading';
    const productContentId = 'js-product-container';
    function addToCart({
        action = 'mda_add_to_cart',
        button,
        productId,
        qty,
        variationId = false,
        additionalData = {},
    }) {
        $('body')
            .find('#' + productContentId)
            .addClass(loadingClass);
        $('body').find('.bottom-bar').addClass('on-loading');
        $.ajax({
            url: base_url + '/wp-json/wc/v3/shop/cart-add-item',
            data: {
                action: action,
                product_id: productId,
                qty: qty,
                variation_id: variationId,
                additional_data: additionalData,
            },
            type: 'post',
            success: function (response) {
                $(document).trigger('added_to_cart');
                getMiniCart();
                showMiniCart();
                $('body')
                    .find('#' + productContentId)
                    .removeClass(loadingClass);
                $('body').find('.bottom-bar').removeClass('on-loading');
            },
        });
    }

    // function handleAjaxBeforeSend(button) {
    //     button.parents('.js-product-box').block({
    //         message: null,
    //         overlayCSS: {
    //             background: '#fff',
    //             opacity: 0.6,
    //         },
    //     });
    //     button.addClass('is-loading').addClass('-disabled');
    //     showHeaderSticky();
    // }

    // function handleAjaxSuccess(response, button) {
    //     button.removeClass('is-loading').removeClass('-disabled');
    //     button.parents('.js-product-box').unblock();

    //     if (response.status == 'ok') {
    //         if (button.hasClass('-add-to-cart-small')) {
    //             button.addClass('is-done');
    //         } else {
    //             button.text('Produkt dodany').addClass('is-done');
    //         }

    //         $(document).trigger('added_to_cart'); // UPDATE MINI CART

    //         if (button.hasClass('-add-to-cart-small')) {
    //             window.setTimeout(function () {
    //                 button.removeClass('is-done');
    //             }, 2000);
    //         } else {
    //             window.setTimeout(function () {
    //                 button.text('Do koszyka').removeClass('is-done');
    //             }, 2000);
    //         }

    //         // WP Fragments render
    //         renderFragments(response);

    //         // Open mini cart
    //         if (window.innerWidth > 1024) {
    //             showMiniCart();
    //         }
    //     }

    //     if (response.status == 'error' && response.message) {
    //         var alert_data = {
    //             type: 'alert:show',
    //             title: response.message,
    //             text: response.text,
    //             error: true,
    //         };
    //         $('body').trigger(alert_data);
    //     }
    // }
})(jQuery);
